import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAssets } from '../redux/assetSlice';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AssetClasses = () => {
  const dispatch = useDispatch();
  const { data: assetClasses = [], status } = useSelector((state) => state.assets);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1
  };

  useEffect(() => {
    if (status === 'idle') {
      dispatch(getAssets());
    }
  }, [dispatch, status]);

  return (
    <div className="row">
      <div className="col-12 text-center">
        <h2 className='heading mt-3 mb-2 mb-md-4 mb-lg-4 mb-xl-4 mt-md-4 mt-lg-4 mt-xl-4'>Asset Classes</h2>
      </div>
      <div className="col-12 ps-3 pe-3">
        {status === 'loading' && <p>Loading...</p>}
        {status === 'failed' && <p>Failed to load asset classes.</p>}
        {status === 'succeeded' && assetClasses.length === 0 && <p>No asset classes available.</p>}
        {status === 'succeeded' && assetClasses.length > 0 && (
          <div className='container p-0'>
            <div className='row d-flex d-sm-flex d-md-none d-lg-none d-xl-none'>
              {assetClasses.map((assetClass) => (
                <div className='col-6 col-md-2 col-sm-2 col-lg-2 p-2' key={assetClass.class_id}>
                  <div className='class-card'>
                    <div className='row'>
                      <div className='col-12 col-md-12 class-image'>
                        <img src={assetClass.class_image} className='img-fluid' alt={assetClass.class_name} />
                      </div>
                      <div className='col-12 col-md-12 class-info'>
                        <h3>{assetClass.class_name}</h3>
                        <p>{assetClass.class_desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='row d-none d-sm-none d-md-flex d-lg-flex d-xl-flex'>
              <Slider {...settings}>
                {assetClasses.map((assetClass) => (
                  <div className='p-3' key={assetClass.class_id}>
                    <div className='class-card'>
                      <div className='row'>
                        <div className='col-12 col-md-12 class-image d-flex justify-content-center align-items-center'>
                          <img src={assetClass.class_image} className='img-fluid' alt={assetClass.class_name} />
                        </div>
                        <div className='col-12 col-md-12 class-info text-center'>
                          <h3>{assetClass.class_name}</h3>
                          <p>{assetClass.class_desc}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetClasses;